
import { computed } from '@vue/composition-api';
import TSPrice from '~/components/ts-components/TSPrice/TSPrice.vue';
import TSBonusCount from '~/components/ts-components/TSBonusCount/TSBonusCount.vue';
import type { ProductExtended, ProductOffer } from '~/type/product/Product';
import ProductOfferList from '~/components/ProductOfferList/ProductOfferList.vue';
interface Props {
  /**
  * Список торговых предложений с моделью текущего товара, но другими хар-ками.
  */
  offer?: ProductOffer[];
  product: ProductExtended;
  /**
   * Является ли товар предзаказом
   */
  isPreOrder?: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  offer: {
    key: "offer",
    required: false,
    type: Array
  },
  product: {
    key: "product",
    required: true,
    type: null
  },
  isPreOrder: {
    key: "isPreOrder",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const pathWithoutID = computed(() => props.product.path.replace(/\d+\//g, ''));
  const discountAmount = computed(() => {
    if (props.product.price?.discount?.type !== 'RRC' && props.product.price?.common?.value && props.product.price?.discount?.value) {
      // Высчитываем разницу в процентах между обычной ценой, и скидочной
      const percent = Math.round((props.product.price.discount.value - props.product.price.common.value) / props.product.price.discount.value * 100);
      // Если скидка больше 20%, возвращаем размер скидки
      if (percent >= 20) return percent;
    }
    return false;
  });
  return {
    pathWithoutID,
    discountAmount
  };
};
__sfc_main.components = Object.assign({
  TSPrice,
  TSBonusCount,
  ProductOfferList
}, __sfc_main.components);
export default __sfc_main;
